import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FiX } from "react-icons/fi";

import { useDispatch, useSelector } from "react-redux";
import {
  createCategory,
  getCategories,
  selectSuccess,
} from "../../redux/features/category/CategorySlice";

const CreateCategory = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [errors, setErrors] = useState({});

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => {
    setIsOpen(false);
    setCategoryName("");
    setErrors({});
  };

  const validateForm = () => {
    const newErrors = {};
    if (!categoryName) newErrors.categoryName = "Name is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const dispatch = useDispatch();
  const isSuccess = useSelector(selectSuccess);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    console.log("Form Data:", { categoryName });

    await dispatch(createCategory({ categoryName }));

    if (isSuccess) {
      await dispatch(getCategories());
      handleClose();
    }
  };

  return (
    <div>
      {/* Button to open the modal */}
      <button
        onClick={handleOpen}
        className="absolute bottom-8 right-8 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
      >
        <FaPlus className="md:text-xl text-[1rem]" />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] md:w-[450px] w-[70%] mx-auto p-5 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-2 mb-4">
              <h1 className="md:text-[1.5rem] text-[1rem] font-bold text-[#0D868C]">
                Create Category
              </h1>
              <button type="button" onClick={handleClose}>
                <FiX className=" size-6 text-[#0D868C]" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Category Name
                </label>
                <input
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  type="text"
                  placeholder="Name"
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
                {errors.categoryName && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.categoryName}
                  </p>
                )}
              </div>

              <div className="text-center mt-8">
                <button
                  type="submit"
                  className="text-white bg-[#0D868C] w-[50%] py-3 rounded-full outline-none uppercase font-normal text-[.9rem]"
                >
                  Create Category
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateCategory;
